export type AuthProvider = 'google' | 'azure-ad';

export function authStateMessage(href: string): {
  message: string | null;
  errorMessage: string | null;
} {
  const state = new URL(href).searchParams.get('auth');
  if (state === 'verified') {
    return {
      message: 'Email verified. Sign in after admin assignment.',
      errorMessage: null,
    };
  }
  if (state === 'verification_failed') {
    return {
      message: null,
      errorMessage: 'Verification link is invalid or expired.',
    };
  }
  return { message: null, errorMessage: null };
}

export function authEndpoint(
  apiBaseUrl: string,
  origin: string,
  path: string
): string {
  return new URL(`auth/${path}`, apiBase(apiBaseUrl, origin)).toString();
}

export function providerSignInUrl(
  provider: AuthProvider,
  apiBaseUrl: string,
  href: string
): string {
  const currentUrl = new URL(href);
  return new URL(
    `auth/signin/${provider}`,
    apiBase(apiBaseUrl, currentUrl.origin)
  ).toString();
}

export function defaultSignInUrl(apiBaseUrl: string, href: string): string {
  const currentUrl = new URL(href);
  const url = new URL('auth/signin', apiBase(apiBaseUrl, currentUrl.origin));
  url.searchParams.set('callbackUrl', cleanAuthUrl(href));
  return url.toString();
}

export function cleanAuthUrl(href: string): string {
  const url = new URL(href);
  url.searchParams.delete('auth');
  return url.toString();
}

export function signupSuccessMessage(verificationEmailSent: boolean): string {
  return verificationEmailSent
    ? 'Check your email to verify your account.'
    : 'Account created. Use the verification link below.';
}

export function authErrorMessage(
  payload: Record<string, unknown>,
  fallback: string
): string {
  if (payload.code === 'email_unverified') {
    return 'Email address is not verified.';
  }
  if (payload.code === 'pending_assignment') {
    return 'Account is pending organization assignment.';
  }
  return typeof payload.error === 'string' ? payload.error : fallback;
}

function apiBase(apiBaseUrl: string, origin: string): URL {
  const withSlash = apiBaseUrl.endsWith('/') ? apiBaseUrl : `${apiBaseUrl}/`;
  return withSlash.startsWith('http')
    ? new URL(withSlash)
    : new URL(withSlash, origin);
}
